module.exports = __webpack_public_path__ + "static/media/Шабалин П. (ДУ).53e85815.pdf";